import styled from "styled-components";
import { Heading, Text } from "../../../services/visualLibraryService";

const RTL = "rtl";

export const ImageDefaultStyled = styled.img`
  max-width: 100%;
  height: auto;
`;

export const ImageStyled = styled.img`
  max-width: 100%;
  height: auto;
  position: absolute;
  opacity: 0;
  transition: opacity 3s ease-in-out;

  &.active {
    opacity: 1;
  }
`;

export const ContainerStyled = styled.section`
  position: absolute;
  top: 50%;
  ${props => `${props.theme.locale.dir === RTL ? "left" : "right"}:
    ${props.theme.components.profileSelector.position.container.vertical}`};
  transform: translateY(-50%);
  width: ${props => props.theme.components.profileSelector.alignment.container};
  height: ${props => props.theme.components.profileSelector.alignment.container};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 ${props => props.theme.components.profileSelector.spacing.large};

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 1px;
    opacity: 0.4;
    background: ${props => props.theme.components.profileSelector.colors.gradient};
  }

  &::after {
    left: auto;
    right: 0;
  }

  > h1 {
    margin-top: 0;
  }
`;

export const TextStyled = styled(Text)`
  font-weight: ${props => props.theme.components.profileSelector.typography.weight};
  text-align: center;
  margin-bottom: 0;
  color: ${props => props.theme.components.profileSelector.colors.secondaryDark};
`;

export const PageContentStyled = styled.article`
  position: absolute;
  top: ${props => props.theme.components.profileSelector.position.container.top};
  //${props => `${props.theme.locale.dir === RTL ? "right" : "left"}: 6rem;
   // ${props.theme.components.profileSelector.position.container.vertical}`};
  width: 100%;
`;

export const HeadingStyled = styled(Heading)`
  ${props => props.textAlign && `text-align: ${props.textAlign}`};
  margin: ${props => props.theme.components.profileSelector.spacing.medium} 0;
`;

export const ProfileListStyled = styled.ul`
  display: inline-block;
  ${props =>
    `margin-${props.theme.locale.dir === RTL ? "right" : "left"}: ${
      props.theme.components.profileSelector.position.list.vertical
    }`};
`;
export const LogoContainerStyled = styled.div`
  ${props => ` margin-${props.theme.locale.dir === RTL ? "right" : "left"}: ${
    props.theme.components.profileSelector.position.container.vertical
  };
    `}
`;
